
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      contact: {
        email: 's-sumita [at] g.ecc.u-tokyo.ac.jp',
        tel: '+81-3-5454-6541',
        fax: '',
        address: `Room 201B, Building 16
        Komaba-I Campus, The University of Tokyo
        3-8-1 Komaba, Meguro-ku, Tokyo
        153-8902, Japan`,
        googlemap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.6962770565606!2d139.68465!3d35.659854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f3510abfcf29%3A0x447d943f8a75b1f8!2sThe%20University%20of%20Tokyo%20-%20Komaba%20Campus!5e0!3m2!1sen!2sjp!4v1661758636946!5m2!1sen!2sjp',
        mapnote: '<a href="https://www.c.u-tokyo.ac.jp/eng_site/info/about/visitors/maps-directions/campusmap.html" target="_blank">Komaba-I Campus Map</a>'
      }
    }
  }
})
